module.exports = __webpack_public_path__ + "img/03.0083f49d.jpg";